// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3SYPx","signatureButtonsRight":"ModalSign_signatureButtonsRight__1GKNA"};